import {getJWT} from 'modules/auth/selectors';
import {store} from 'app/store';

/**
 * @Deprecated
 */
export default class BaseRepository {

    static parseJSON = response => {
        return response.json();
    };

    static headers = () => {
        const jwt = getJWT(store.getState());
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (jwt) {
            headers.Authorization = `Bearer ${jwt}`;
        }
        return new Headers(headers);
    };

    //TODO: On 403: Don't redirect to login page, but show message "Pls try logging in again".

    //TODO: On 401: Try to refresh once! If successful, retry last action.
}